/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Space } from "antd";
import CustomInfiniteScroll from "../../../../../Shared/components/CustomInfiniteScroll";
import { deliveryLineHeadView } from '../../../../../../config/constant';
import { TableCell, TableRow } from "@mui/material";
import { getColumnWidth, currencyFormat } from "../../../../../../helpers/utilities";


export const DeliveryLinesList = React.forwardRef((props, ref) => {
    const { classes, clsx, lines, loadMore } = props;

    return (
        <div className={clsx(classes.tableRoot)}>
            <CustomInfiniteScroll
                loadMore={true}
                loadMoreContent={false}
                heads={deliveryLineHeadView}
                width={true}
                component={
                    <>
                        {
                            !loadMore ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={deliveryLineHeadView?.length}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <>
                                    {
                                        lines?.length > 0 ? lines.map((data, i) => (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i}>
                                                <TableCell style={{ width: getColumnWidth(deliveryLineHeadView, 1) }}><span style={{ width: getColumnWidth(deliveryLineHeadView, 0) }}>{data?.lineNumber}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(deliveryLineHeadView, 2) }}><span style={{ width: getColumnWidth(deliveryLineHeadView, 1) }} ><span className={classes.descEllipsis}>{data?.product?.productId || '---'}</span></span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(deliveryLineHeadView, 3) }}><span style={{ width: getColumnWidth(deliveryLineHeadView, 1) }} ><span className={classes.descEllipsis}>{data?.description || '---'}</span></span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(deliveryLineHeadView, 4) }}><span style={{ width: getColumnWidth(deliveryLineHeadView, 2) }}>{data?.quantity || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(deliveryLineHeadView, 5) }}><span style={{ width: getColumnWidth(deliveryLineHeadView, 4) }}>{data.unit?.name || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(deliveryLineHeadView, 6) }} className={classes.textAlignRight}><span style={{ width: getColumnWidth(deliveryLineHeadView, 5) }}>{`₹ ${currencyFormat(data?.pricePerUnit || 0)}`}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(deliveryLineHeadView, 7) }} className={classes.textAlignRight}><span style={{ width: getColumnWidth(deliveryLineHeadView, 7) }}>{`₹ ${currencyFormat(data?.amount || 0)}`}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(deliveryLineHeadView, 8) }}><span style={{ width: getColumnWidth(deliveryLineHeadView, 8) }}>{data?.quantity || '---'}</span></TableCell>
                                                <TableCell className={classes.textAlignRight}>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={clsx(classes.iconPadding)}>

                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell style={{ textAlign: "center" }} colSpan={deliveryLineHeadView?.length}>
                                                <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Start by Adding Lines to your Delivery'}</p>
                                            </TableCell>
                                        </TableRow>
                                    }
                                </>
                            )
                        }
                    </>
                }
            />
        </div>
    )
})